const relatoriosRoutes = [
  {
    path: '/relatorios/locacao',
    name: 'relatorios.locacao',
    component: () => import('../views/relatorios/RelatorioLocacao.vue'),
  },
  {
    path: '/relatorios/contas-receber',
    name: 'relatorios.contas.receber',
    meta: {
      title: 'Relatório de contas a receber',
    },
    component: () => import('../views/relatorios/RelatorioContasReceber.vue'),
  },
  {
    path: '/relatorios/contas-pagar',
    name: 'relatorios.contas.pagar',
    meta: {
      title: 'Relatório de contas a pagar',
    },
    component: () => import('../views/relatorios/RelatorioContasPagar.vue'),
  },
  {
    path: '/relatorios/insumos',
    name: 'relatorios.insumos',
    component: () => import('../views/relatorios/RelatorioInsumos.vue'),
  },
  {
    path: '/relatorios/disponibilidade-veiculos',
    name: 'relatorios.disponibilidade-veiculos',
    component: () => import('../views/relatorios/DisponibilidadeVeiculos.vue'),
  },
  {
    path: '/relatorios/produto-estoque-preco',
    name: 'relatorios.produto-estoque-preco',
    component: () => import('../views/relatorios/RelatorioProdutoEstoquePreco.vue'),
  },
  {
    path: '/relatorios/locacao/pdl',
    name: 'relatorios.pdl',
    component: () => import('../views/relatorios/RelatorioPDL.vue'),
  },
];

export default relatoriosRoutes;
